/* eslint-disable array-callback-return */
// React
import React, { useState } from 'react';
import { Button, Col, Row, Table } from 'reactstrap';

// Components
import { ModalDependent } from './component/ModalDependent';
import { ItemListDependent } from './component/ItemListDependent';
import { ModalEditDependent } from './component/ModalEditDependent';

// Helpers
import Axios from 'axios';
import moment from 'moment';
import * as url from '../../../../../../helpers/url_helper';

export const DependentsInfo = ({
  isView,
  validation,
  kinshipsData,
  maxDependents,
  toggleAssistenceDependent,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isCPFRequired, setIsCPFRequired] = useState(true);
  const [itemSelected, setItemSelected] = useState(undefined);
  const [isModalEditVisible, setIsModalEditVisible] = useState(false);

  // Toggles
  const toggleModalEdit = () => {
    setIsModalEditVisible((prevState) => !prevState);
  };

  function toggle() {
    setIsVisible(!isVisible);
  }

  // Functions
  const verifyAgeOfDependent = (date) => {
    let years = moment().diff(date, 'years');

    // if the dependent is 8 years old or younger, CPF is not required
    setIsCPFRequired(years > 8);
  };

  const verifyIfExistDependent = async (cpf) => {
    const response = await Axios.get(url.BASE + `/customer/find-by-cpf/${cpf}`);

    if (response.status === 200) {
      return {
        customer_hashid: response.customer.hashid,
        customer_id: response.customer.id,
        name: response.customer.name,
        cpf: response.customer.cpf,
        gender: response.customer.gender.toUpperCase(),
        birthdate: response.customer.birthdate,
        kinship_name: '',
        kinship_id: '',
      };
    }
  };

  const verifyIfCanAddMoreDependent = () => {
    return getDependetsNoDeleteds() < maxDependents;
  };

  const handleSubmit = (data) => {
    let target = {};

    if (itemSelected !== undefined) {
      target = {
        target: {
          name: 'dependents',
          value: validation.values.dependents.map((item, indexMap) => {
            return indexMap === itemSelected
              ? { card_number: item.card_number, ...data }
              : item;
          }),
        },
      };
    } else {
      target = {
        target: {
          name: 'dependents',
          value: [...validation.values.dependents, data],
        },
      };
    }

    validation.handleChange(target);
  };

  const handleDeleteDependents = () => {
    const target = {
      target: {
        name: 'dependents',
        value: validation.values.dependents.map((item, indexMap) =>
          indexMap === itemSelected
            ? { ...validation.values.dependents[itemSelected], deleted: true }
            : item
        ),
      },
    };
    validation.handleChange(target);
  };

  // GET calls
  const getDependetsNoDeleteds = () => {
    const values = validation.values.dependents.filter((item) => {
      return item.deleted !== true;
    });

    return values.length;
  };

  return (
    <Row>
      <Col md={12}>
        <p className="h4 mb-4">Dependentes</p>
      </Col>
      <Col md={12}>
        {getDependetsNoDeleteds() > 0 ? (
          <Table className="invoice-table table-borderless mb-0" responsive>
            <thead className="align-middle">
              <tr className="table-active">
                <th scope="col" style={{ width: '50px' }}>
                  #
                </th>
                <th scope="col">CPF</th>
                <th scope="col">Nome</th>
                <th scope="col">
                  <div className="d-flex currency-select input-light align-items-center">
                    Nascimento
                  </div>
                </th>
                <th scope="col">Gênero</th>
                <th scope="col">Parentesco</th>
                <th scope="col">Assistência funerária</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {validation.values.dependents.map((item, index) => {
                if (!item.deleted) {
                  return (
                    <ItemListDependent
                      key={index}
                      handleChangeDependents={() => {
                        setItemSelected(index);
                        toggle();
                      }}
                      item={item}
                      index={index}
                      isView={isView}
                      kinshipsData={kinshipsData}
                      verifyIfExistDependent={verifyIfExistDependent}
                    />
                  );
                }
              })}
            </tbody>
          </Table>
        ) : (
          <div>
            <p className="ms-2">Nenhum dependente cadastrado</p>
          </div>
        )}
        {!isView && (
          <Button
            className="btn btn-soft-secondary fw-medium"
            id="add-item"
            onClick={() => {
              setItemSelected(undefined);
              if (verifyIfCanAddMoreDependent()) {
                toggle();
              } else {
                alert('Limite de dependentes atingido');
              }
            }}
          >
            <i className="ri-add-fill me-1 align-bottom"></i> Adicionar
            dependente
          </Button>
        )}
        <ModalDependent
          handleSubmit={handleSubmit}
          isCPFRequired={isCPFRequired}
          verifyAgeOfDependent={verifyAgeOfDependent}
          handleDeleteDependents={handleDeleteDependents}
          item={
            itemSelected !== undefined
              ? validation.values.dependents[itemSelected]
              : null
          }
          toggle={toggle}
          isVisible={isVisible}
          kinshipsData={kinshipsData}
          toggleModalEdit={toggleModalEdit}
          verifyIfExistDependent={verifyIfExistDependent}
          toggleAssistenceDependent={toggleAssistenceDependent}
        />
        <ModalEditDependent
          item={
            itemSelected !== undefined
              ? validation.values.dependents[itemSelected]
              : null
          }
          toggle={toggleModalEdit}
          kinshipsData={kinshipsData}
          handleSubmit={handleSubmit}
          isCPFRequired={isCPFRequired}
          isVisible={isModalEditVisible}
          resetValues={() => setItemSelected(undefined)}
          handleDeleteDependents={handleDeleteDependents}
          verifyIfExistDependent={verifyIfExistDependent}
          toggleAssistenceDependent={toggleAssistenceDependent}
        />
      </Col>
    </Row>
  );
};
